<template>
  <div class="pa1 pa3-l layout">
    <state-stats/>
    <closed-stats/>
    <current-stats v-if="false"/> <!-- это не пока не используем -->
    <closed-with-warnings/>
    <!--
    <user-duties/>
    -->
    <user-duties-ex/>
    <average-duration/>
    <average-invited/>
  </div>
</template>

<script>
import CardEmpty from '@/components/dashboard/CardEmpty.vue'
import lazyLoad from '@/utils/lazyLoadComponent.js'

function lz (importFn) {
  return lazyLoad({
    componentFactory: importFn,
    preloader: CardEmpty
  })
}

export default {
  components: {
    StateStats: lz(() => import(/* webpackChunkName: "StateStats" */'@/components/dashboard/widgets/StateStats.vue')),
    ClosedStats: lz(() => import(/* webpackChunkName: "CurrentStats" */'@/components/dashboard/widgets/ClosedStats.vue')),
    CurrentStats: lz(() => import(/* webpackChunkName: "CurrentStats" */'@/components/dashboard/widgets/CurrentStats.vue')),
    ClosedWithWarnings: lz(() => import(/* webpackChunkName: "ClosedWithWarnings" */'@/components/dashboard/widgets/ClosedWithWarnings.vue')),
    UserDuties: lz(() => import(/* webpackChunkName: "UserDuties" */'@/components/dashboard/widgets/UserDuties.vue')),
    UserDutiesEx: lz(() => import(/* webpackChunkName: "UserDuties" */'@/components/dashboard/widgets/UserDutiesEx.vue')),
    AverageDuration: lz(() => import(/* webpackChunkName: "AverageDuration" */'@/components/dashboard/widgets/AverageDuration.vue')),
    AverageInvited: lz(() => import(/* webpackChunkName: "AverageInvited" */'@/components/dashboard/widgets/AverageInvited.vue'))
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-gap: 1rem;
}
@media only screen and (min-width: 60em) {
  .layout {
    grid-gap: 1rem;
  }
}
</style>
